import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import enUS from './locales/en-US.json';
import th from './locales/th.json';

i18n
    .use(HttpApi) // load translation using http -> see /public/locales
    .use(LanguageDetector) // detect user language
    .use(initReactI18next)
    .init({
        resources: {
            'en-US': {
                translation: enUS
            },
            th: {
                translation: th
            }
        },
        lng: 'th', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        fallbackLng: 'th', // use 'en-US' if detected language is not available
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });

export default i18n;